import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import store from './store'
import router from './router'
import Vuelidate from 'vuelidate'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import { faSpinner, faHeart, faEllipsisH, faMapMarkerAlt, faPlay, faPause, faStop, faArrowLeft, faArrowRight, faVolumeMute, faShare, faMusic, faUserFriends, faHeadphones } from '@fortawesome/free-solid-svg-icons'
import { faHeart as faHeartOutline } from '@fortawesome/free-regular-svg-icons'

library.add(
    faHeart, faHeartOutline, faSpinner, faEllipsisH, faMapMarkerAlt, faPlay, faShare, faMusic, faUserFriends,
    faHeadphones, faPause, faStop, faArrowLeft, faArrowRight, faVolumeMute
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(Vuelidate)


Vue.config.productionTip = false


axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_URL;

axios.interceptors.request.use((config) => {
    store.commit('loading', true);
    return config;
    }, (error) => {
    store.commit('loading', false);
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    store.commit('loading', false);
    return response;
    }, (error) => {
    store.commit('loading', false);
    return Promise.reject(error);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
